import { FC } from "react";
import RestaurantAnalyticsTabsDashboard from "../components/RestaurantAnalyticsTabsDashboard";

const RestaurantAnalyticsDashboard: FC = () => {
  return <RestaurantAnalyticsTabsDashboard />;
};

export default RestaurantAnalyticsDashboard;
